import { BaseClient } from '../client';
import { TRevenda } from './shopkeeper.types';

export const putShopkeeper = async (body: TRevenda) => {
	if (process.env.NODE_ENV === 'development') {
		return 'Alterado com sucesso';
	}

	try {
		const response = await BaseClient.put<string>(`/Revendas/${body.id}`, body).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
